document.addEventListener("DOMContentLoaded", function () {
  const content = document.getElementById("articleContent");
  const tocList = document.getElementById("tocList");
  const tocContainer = document.getElementById("toc");
  if (!content || !tocList || !tocContainer) return;

  const stickyWrapper = tocContainer.closest(".sticky");

  // dynamic limit
  const isMobile = window.innerWidth < 1024;
  const maxVisible = isMobile ? 5 : 15;

  const headings = content.querySelectorAll("h2, h3");
  const allItems = [];

  headings.forEach((heading) => {
    let slug = heading.textContent
      .trim()
      .replace(/[\s]+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-+/g, "-");

    heading.id = slug;

    const tag = heading.tagName.toLowerCase();
    const isH2 = tag === "h2";
    const isH3 = tag === "h3";

    const linkClass = isH2 ? "toch2" : "toch3";

    allItems.push(`
      <div class="toc-item ${isH3 ? "toc-sub" : ""}">
        <a class="${linkClass}" href="#${slug}" title="${heading.textContent}">
          ${heading.textContent}
        </a>
      </div>
    `);
  });

  if (allItems.length <= maxVisible) {
    tocList.innerHTML = allItems.join("");
    return;
  }

  // collapsed initial state
  tocList.innerHTML = allItems.slice(0, maxVisible).join("");

  const toggleBtn = document.createElement("button");
  toggleBtn.type = "button";
  toggleBtn.className = "btn btn--secondary w-full mt-4 text-left";
  toggleBtn.textContent = "Show all headings";

  let expanded = false;

  toggleBtn.addEventListener("click", function () {
    expanded = !expanded;

    if (expanded) {
      tocList.innerHTML = allItems.join("");
      tocList.classList.add("toc-scroll");
      if (stickyWrapper) stickyWrapper.classList.remove("sticky");
      toggleBtn.textContent = "Show less";
    } else {
      tocList.innerHTML = allItems.slice(0, maxVisible).join("");
      tocList.classList.remove("toc-scroll");
      if (stickyWrapper) stickyWrapper.classList.add("sticky");
      toggleBtn.textContent = "Show all headings";
    }
  });

  tocList.parentNode.appendChild(toggleBtn);
});